import { BenQuery } from './BenQuery'

export class BenProxyClick {
  static init(dones) {
    const $px = BenQuery.query('[ben-js="proxy-event"]')
    $px.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item)
    })
  }
}

function _init($px: HTMLElement) {
  $px.addEventListener('click', () => {
    console.log(111)
    const selector = $px.getAttribute('selector')
    if (!selector) return
    const $target = document.querySelector(selector) as HTMLElement | null
    $target?.click()
  })
}
